(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	require('smooth-scroll');

	$('[data-smooth-scroll]').smoothScroll();
})();
